module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/small/package_xl.0359fefa.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/small/package_xl.png
// module id = 995
// module chunks = 16